export default {
  
  data() {
    return {
      ttBrandName: null
    }
  },

  methods: {
    initTooltips(brand) {
      switch (brand) {
        case 'bmw':
        case 'mini':
          this.ttBrandName = brand.toUpperCase();
          break;
          
        default:
          this.ttBrandName = 'BMWMotorrad';
          break;
      }
    },

    getKpiLongtextToolTip(kpiCode) {
      return this.$t(`Webportal.CX.Tooltips.${this.ttBrandName}.${kpiCode.replace('GRP_', '').replaceAll(' ', '_').replaceAll('/', '_')}`);
    }
  }
};
